import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import amwayLogo from '../../../src/assets/image/Amw_Logo_Black.webp';
import { DynamicObjectInterface } from '../../sdk/type';
import ParticipantService from '../../sdk/services/participantService';
import { useAPICall } from '../../hooks';
import styles from './Profile.module.scss';

export const Certificate = () => {
  const [data, setData] = useState();

  const location = useLocation();
  const apiCall = useAPICall();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const campaignId = params.get('campaignId') ?? '';
    const teamId = params.get('teamId') ?? '';
    const code = params.get('code') ?? '';
    fetchData({ campaignId, teamId, code });
  }, [location]);

  const fetchData = async (detail: DynamicObjectInterface) => {
    const res = await apiCall(ParticipantService.getCertificate, detail);
    return setData(res?.data?.data);
  };

  return (
    <>
      <div className={styles['certificate']}>
        <div className={styles['image-container']}>
          <img onClick={() => navigate('/')} className={styles['logo']} src={amwayLogo} alt="amway logo" height={30} />
        </div>

        <div className={styles['content-container']}>
          <img className={styles['content-container-image']} src={data} alt="certificate" />
        </div>
      </div>
    </>
  );
};
